module.exports = __webpack_public_path__ + "img/icon_fbmess-blue.375569ad.svg";